import { ReadProjectStorePeriod } from "@/types/projectStorePeriod";
import { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import PeriodDate from "../components/PeriodDate";
import { SelectAllHeader } from "@/components/data-table/components/SelectAllHeader";
import { PeriodFilter } from "@/modules/projects/types/periodFilter";

const usePeriodsColumns = <T extends { id: string }>(
  data: ReadProjectStorePeriod[],
  filter: PeriodFilter,
) => {
  const periods = useMemo(() => {
    if (data.length === 0) {
      return [];
    }
    return data[0].periods;
  }, [data]);

  const rowIds = useMemo(() => data.map((store) => store.id), [data]);

  const selectStore = useMemo<ColumnDef<T>>(() => {
    return {
      header: () => <SelectAllHeader rowIds={rowIds} />,
      accessorKey: "selectStore",
    };
  }, [rowIds]);

  const columns = useMemo(() => {
    return periods
      .map((period) => {
        if (period.period < filter.fromDate || period.period > filter.toDate) {
          return;
        }
        return {
          header: () => <PeriodDate date={period.period} />,
          accessorKey: period.id,
        };
      })
      .filter((column) => column !== undefined);
  }, [periods, filter.fromDate, filter.toDate]);

  const periodsColumns = useMemo(() => {
    return {
      columns: [selectStore, ...columns],
    };
  }, [columns, selectStore]);

  return periodsColumns;
};

export default usePeriodsColumns;
